module.exports = __webpack_public_path__ + "static/media/view_lsr.6c9be5d1.svg";